import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.CONSOLE_VERSION](state) {
        return state.console_version;
    },
    [GETTERS.IS_OUT_OF_DATE](state) {
        return state.is_out_of_date;
    },
};
